import WVC from '@xfe/webview-community';
import { noop } from '@src/utils/common-util';
import { isJianghuDaily } from 'detect-mobile-device';

/**
 * 发送 API 请求到推栏客户端
 * @type {Function}
 */
let postMessage = noop;

/**
 * 初始化
 */
if (isJianghuDaily()) {
  WVC.web.init(window);
  postMessage = WVC.web.postMessage;
}

/**
 * 打开 [账号选择弹窗] 弹窗, 用于在专题页面中可以切换 [账号] 或 [角色]
 * @param {boolean} [selectRole] - 是否使用角色, 如果设置为 false 时将在弹窗中仅显示"切换角色账号".
 * 当设置为 true 时, 弹窗将有一项可以切换"游戏角色", 默认: false
 * @param {string[]} [gameList] - 可选, 游戏类型, 如: ['jx3', 'jw3yq']
 * @return {Promise<void>}
 */
async function showAccountModal(selectRole = false, gameList) {
  await postMessage(WVC.EventNames.SHOW_ACCOUNT_MODAL, { selectRole, gameList });
}

/**
 * 改变推栏分享参数
 * @param {boolean} [shouldShareLand]
 * @returns {Promise<void>}
 */
async function changeShareParam(shouldShareLand = false) {
  await postMessage(WVC.EventNames.APP_CHANGE_SHARE_PARAM, { shouldShareLand });
}

/**
 * 当分享时
 * @param {function} [fn] - 执行函数
 */
function whenShare(fn) {
  if (isJianghuDaily()) {
    WVC.web.register(WVC.EventNames.APP_SHARE_START, () => {
      if (fn) {
        fn();
      }
    });
  }
}

/**
 * 分享成功后
 * @param {function} [fn] - 分享成功后回调
 */
function shareSuccess(fn) {
  if (isJianghuDaily()) {
    WVC.web.register(WVC.EventNames.APP_SHARE_SUCCESS, () => {
      if (fn) {
        fn();
      }
    });
  }
}

/**
 * 保存图片
 * @param {string} url - 图片地址, 支持绝对 http 路径或 base64
 */
function saveImage(url) {
  postMessage(WVC.EventNames.SAVE_IMAGE, url);
}

/**
 * 切换推栏横竖屏
 * @param {string} [type] - 改变方向的类型, 默认: 'portrait' - 竖屏; 'landscape'-横屏
 * @returns {Promise<void>}
 */
const orientationType = {
  landscape: 'APP_CHANGE_ORIENTATION_LANDSCAPE',
  portrait: 'APP_CHANGE_ORIENTATION_PORTRAIT'
};
async function changeOrientation(type = 'portrait') {
  await postMessage(WVC.EventNames[orientationType[type]]);
}

const dailyWebviewComm = {
  /**
   * 打开 [账号选择弹窗] 弹窗, 用于在专题页面中可以切换 [账号] 或 [角色]
   */
  showAccountModal,
  /**
   * 改变推栏分享参数
   */
  changeShareParam,
  /**
   * 当分享时
   */
  whenShare,
  /**
   * 分享成功后
   */
  shareSuccess,
  /**
   * 切换推栏横竖屏
   */
  changeOrientation,
  /**
   * 保存图片
   */
  saveImage
};

export default dailyWebviewComm;
